import React from "react";
import { copy } from "shared/assets";

import { Button, List, Message, Modal } from "shared/components";
import { Spacer } from "shared/layout";
import { IStatus, ITheme } from "shared/types";

const { messages } = copy.permissions.editPermissions;

interface RedirectToPermissionsModalProps {
  handleRedirect: () => void;
  handleClose: () => void;
}

export const RedirectToPermissionsModal: React.FC<RedirectToPermissionsModalProps> =
  ({ handleRedirect, handleClose }) => {
    return (
      <Modal
        handleClose={handleClose}
        dataTestId="set_permissions_redirect_modal"
      >
        <Spacer size="s">
          <Message status={IStatus.info}>
            <List>
              <li>{messages.redirectPermissions1}</li>
              <li>{messages.redirectPermissions2}</li>
            </List>
          </Message>
          <Spacer size="s" spaceDirection="horizontal">
            <Button
              data-testid="set_permissions_redirect_button"
              onClick={handleRedirect}
            >
              Set permissions
            </Button>
            <Button
              data-testid="set_permissions_cancel_button"
              onClick={handleClose}
              theme={ITheme.secondary}
            >
              Do it later
            </Button>
          </Spacer>
        </Spacer>
      </Modal>
    );
  };
